module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-contact-contact-remark"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('div', _vm._l((_vm.rows), function(row) {
    return _c('lxm-row', {
      attrs: {
        "name": row.name
      }
    }, [_c('template', {
      slot: "content"
    }, [_vm._v("\n            " + _vm._s(row.content) + "\n            "), _c('p', {
      staticClass: "lxm-contact-contact-remark__inscription has-text-right"
    }, [_vm._v("\n              ——\n              "), _c('span', {
      staticClass: "lxm-contact-contact-remark__inscription-user"
    }, [_vm._v("\n                " + _vm._s(row.user) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "lxm-contact-contact-remark__inscription-update"
    }, [_vm._v("\n                " + _vm._s(row.update) + "\n              ")])])])], 2)
  })) : _vm._e()])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be6b4b7c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be6b4b7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Contact/Contact/Remark.vue
// module id = 885
// module chunks = 0